import { handleHttpResponse } from "../utils/http_response_utils";

export const uploadCollectionData = async (data) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/upload-collection-data", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: data
  });
  return handleHttpResponse(response)
};
